import React from "react";

const H2 = ({ heading, className = "" }) => {
    return <h2 className={`text-2xl font-bold border-b-2 border-gray-200 pb-2 mb-4 ${className}`}>{heading}</h2>
}

export default H2;
